import { REVIEW_LABELS, STATUS_DESCRIPTIONS } from "../lib/labels";
import type { AuditStatus, ReviewState, RunStatus } from "../types/api";

export function StatusBadge({ status }: { status: AuditStatus }) {
  return (
    <span className={`badge badge--${status.toLowerCase()}`} title={STATUS_DESCRIPTIONS[status]}>
      {status}
    </span>
  );
}

export function ReviewBadge({ state }: { state: ReviewState }) {
  return <span className={`review-badge review-badge--${state.toLowerCase()}`}>{REVIEW_LABELS[state]}</span>;
}

const RUN_LABELS: Record<RunStatus, string> = {
  CREATED: "Created",
  VALIDATING: "Validating",
  READY: "Ready",
  PROCESSING: "Processing",
  COMPLETED: "Completed",
  FAILED: "Failed",
};

export function RunStatusBadge({ status }: { status: RunStatus }) {
  const tone = status === "COMPLETED" ? "pass" : status === "FAILED" ? "hold" : "neutral";
  return <span className={`badge badge--${tone}`}>{RUN_LABELS[status]}</span>;
}
